// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "Breakdown__textCenter__anUJk";
export const breakdownWrapper = "Breakdown__breakdownWrapper__5KA55";
export const breakdown = "Breakdown__breakdown__-N63U";
export const breakdownChart = "Breakdown__breakdownChart__cw0XE";
export const bar = "Breakdown__bar__-7Pc4";
export const barContainer = "Breakdown__barContainer__99wd6";
export const expanded = "Breakdown__expanded__pH-bx";
export const actualValue = "Breakdown__actualValue__z46BK";
export const projectionValue = "Breakdown__projectionValue__MpT4G";
export const withProjections = "Breakdown__withProjections__fCcVn";
export const accountBreakdown = "Breakdown__accountBreakdown__-699j";
export const chartContainer = "Breakdown__chartContainer__Sgx6U";
export const overlay = "Breakdown__Overlay__J9uRH";
export const ctaWrapper = "Breakdown__ctaWrapper__3nx4g";
export const seeAllButtonRow = "Breakdown__seeAllButtonRow__tc++a";
export const legendWrapper = "Breakdown__legendWrapper__3HxKS";
export const nameWrapper = "Breakdown__nameWrapper__lE60L";
export const icon = "Breakdown__icon__0VRkg";
export const name = "Breakdown__name__7x8+s";
export const tooltipContainer = "Breakdown__tooltipContainer__iMUZ6";
export const projectionTooltipContainer = "Breakdown__projectionTooltipContainer__X-YfS";
export const projectionBar = "Breakdown__projectionBar__-+uyq";
export const limitIconWrapper = "Breakdown__limitIconWrapper__iPzkq";
export const hidden = "Breakdown__hidden__-Alyl";
export const overlappedZeroValue = "Breakdown__overlappedZeroValue__w7vG9";
export const member = "Breakdown__member__3motv";
export const actualValuesLabel = "Breakdown__actualValuesLabel__fBLaj";
export const projectionValuesLabel = "Breakdown__projectionValuesLabel__8NkIE";
export const valueLabels = "Breakdown__valueLabels__7ToU+";
export const limitIcon = "Breakdown__limitIcon__n5F2T";
export const peers = "Breakdown__peers__X2Gq1";
export const others = "Breakdown__others__T9oPZ";
export const light = "Breakdown__light__awuKp";